module.exports = __webpack_public_path__ + "static/media/web.fb784ee7.png";